import { FC, ReactElement } from 'react';
import { Grid } from 'react-styled-flexboxgrid';
import { useMedia } from 'react-use';

import { media } from '@savgroup-front-common/constants';

import { useLayout } from '../NewLayout.hooks';

import { $Content, $ContentWrapper } from './BanneredLayout.styles';
import useBannerUrl from './hooks/useBannerUrl';

const Content: FC<{
  children?: ReactElement | ReactElement[];
}> = ({ children }) => {
  const isGridFluidActive = useMedia(media.maxWidth.md);
  const { enableServicePortal } = useLayout();
  const bannerUrl = useBannerUrl();

  return (
    <$ContentWrapper>
      <Grid fluid={isGridFluidActive}>
        <$Content
          $enableServicePortal={enableServicePortal}
          $hasBannerUrl={!!bannerUrl}
        >
          {children}
        </$Content>
      </Grid>
    </$ContentWrapper>
  );
};

Content.displayName = 'Content';
export default Content;
